export interface WorkflowRegistration {
  userId: string;
  workflowId: string;
  inputParams: string[];
}
